import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ trigger, title, body, confirmLabel, onConfirm, testId, cancelLabel = "Keep it", calm = false, extra = null }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className="rounded-2xl bg-white" data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display font-medium text-charcoal text-xl">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-ink-soft">{body}</AlertDialogDescription>
      </AlertDialogHeader>
      {extra}
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel className="rounded-full" data-testid={`${testId}-cancel-btn`}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction className={`rounded-full text-white ${calm ? "bg-charcoal hover:bg-charcoal/90" : "bg-warn hover:bg-warn/90"}`} onClick={onConfirm} data-testid={`${testId}-confirm-btn`}>{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
